import PageWrapper from "components/PageWrapper";
import { SanghaMembershipPending, SanghaMembershipPendingProps } from "./SanghaMembershipPending";

export const SanghaMembershipPendingPage = (props: SanghaMembershipPendingProps) => (
    <PageWrapper>
        <SanghaMembershipPending {...props} />
    </PageWrapper>
);
